SupportV2FlexibleContactChannelsTemplate = require '../../../../v2_flexible_contact_channels.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormV2FlexibleContactChannelsTextView extends Backbone.View
  className: 'flexible-contact-channels-text-view'
  events:
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container' : 'handleDisplayOfPrimaryLiveChatLink'
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container' : 'handleDisplayOfSecondaryLiveChatLink'
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container' : 'handleDisplayOfTertiaryLiveChatLink'
    'click .flex-email-link': 'renderEmailForm'
    'click .flex-phone-link': 'renderPhoneView'
    'click .flex-chat-link': 'renderChatClickView'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportV2FlexibleContactChannelsTemplate
    @model = Groupon.Support.FlexibleContactChannelModel
    @mainView = @options.mainView

  render: () ->
    @model.presentContactChannels()
    @$el.empty()
    options =
      withoutChat: not @isLiveChatEnabled()
      renderLayout: true
    @$el.html(@arrangeLayoutView(@toHash(options)))
    this

  isLiveChatEnabled: () ->
    Groupon.Support.LiveChatModel.isLiveChatEnabled()

  renderEmailForm: (e)->
    @mainView.renderEmailForm()

  renderPhoneView: ()->
    @mainView.renderPhoneNumberView()

  renderChatClickView: () ->
    @mainView.renderChatClickView()

  handleDisplayOfPrimaryLiveChatLink: ()->
    primaryChatTextElem = $(".flex-chat-channel-text")
    @toggleDomElemsBasedOnLiveChat primaryChatTextElem
    @$el.find('.flex-contact-channels-without-chat').empty()
    if window.liveChatLinkVisible()
      window.showDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.hideDOMElems $('.flex-contact-channels-without-chat')
    else
      window.hideDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.showDOMElems $('.flex-contact-channels-without-chat')
      $('.flex-contact-channels-without-chat').html(@arrangeLayoutView(@toHash({withoutChat: true})))

  handleDisplayOfSecondaryLiveChatLink: ()->
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]
    if @model.get('formattedContactChannels').contact_channels.length is 2 then DOMelemsToToggle.push $('.flex-secondary-channel-also-text')
    @toggleDomElemsBasedOnLiveChat DOMelemsToToggle

  handleDisplayOfTertiaryLiveChatLink: ()->
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    @toggleDomElemsBasedOnLiveChat [tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]

  toggleDomElemsBasedOnLiveChat:(domElems)->
    if window.liveChatLinkVisible()
      window.showDOMElemsInline domElems
    else
      window.removeDOMElemsInline domElems
      window.hideDOMElems domElems

  toHash: ({withoutChat, renderLayout})->
    contactChannelhash = {}
    if withoutChat
      contactChannelhash = @model.get('contactChannelsWithoutBoldChat')
    else if @model.has('formattedContactChannels')
      contactChannelhash = @model.get('formattedContactChannels')
    else
      contactChannelhash = @model.get('contactChannelsWithoutBoldChat')

    additionalInfo =
      isVertical: true
    if renderLayout
      additionalInfo.renderLayout = true
    hash = $.extend true, additionalInfo, contactChannelhash
    hash

  arrangeLayoutView: (hash) ->
    html = toHtml(@template, hash, @I18nScope)
    $html = $(html)
    $html.find('.flexible-contact-channel-icon-container').hide()
    $html.find('.recommended').hide()
    $html

  renderLiveChat: ()->
    if @model.get('liveChatExists')
      if @model.get("primaryChannelIsBoldChat")
        @mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        })
      @mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: @model.get("primaryChannelIsBoldChat")
      })

module.exports = EmailFormV2FlexibleContactChannelsTextView
